import { render, staticRenderFns } from "./ContainerCard.vue?vue&type=template&id=563bfc85&"
import script from "./ContainerCard.vue?vue&type=script&lang=js&"
export * from "./ContainerCard.vue?vue&type=script&lang=js&"
import style0 from "./ContainerCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports